import Modal from '@hero/ui-kit/components/Modal';
import Button from '@hero/ui-kit/inputs/Button';
import H from '@hero/ui-kit/typography/H';
import P from '@hero/ui-kit/typography/P';
import React from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getUserDeviceDetails } from '@hero/redux-data/backoffice/userDeviceDetails/actionCreators';
import QueryInlineError from '../../../../components/QueryInlineError';
import useRevokeUserTokens from '../../api/useRevokeUserTokens';

interface RevokeUserTokensProps {
    id: number;
    email?: string;
    firstName?: string;
    lastName?: string;
}

const RevokeUserTokens: React.FC<RevokeUserTokensProps> = ({ email, firstName, lastName, id }) => {
    const dispatch = useDispatch();
    const [showEdit, setShowEdit] = React.useState(false);
    const { user_id } = useParams();

    const handleClose = () => {
        setShowEdit(false);
        user_id && dispatch(getUserDeviceDetails({ user_id: +user_id }));
    };
    const { mutate, isError, isPending, isSuccess, error } = useRevokeUserTokens();

    const handleSubmit = () => {
        mutate({ hero_user_id: id });
    };

    const name = React.useMemo(() => {
        if (firstName || lastName) {
            return `${firstName} ${lastName}`;
        }

        return '-';
    }, [firstName, lastName]);

    return (
        <>
            <div
                style={{ display: 'flex', alignItems: 'center', columnGap: '1rem', height: '2rem' }}
            >
                <Button size="small" onClick={() => setShowEdit(true)}>
                    Logout user from all devices
                </Button>
            </div>

            <Modal
                type={isSuccess ? 'success' : 'neutral'}
                onClose={handleClose}
                isCancelable
                externalControls={[showEdit, setShowEdit]}
            >
                {isSuccess ? (
                    <>
                        <P centered size="large" strong>
                            {`Successfully revoked the tokens for ${name}`}
                        </P>
                        <Button onClick={handleClose} width="full">
                            Close
                        </Button>
                    </>
                ) : (
                    <>
                        <H centered role="h5">{`Revoke tokens`}</H>
                        <P
                            centered
                        >{`Are you sure you want to revoke all tokens and logout user from all devices for ${name} (${email})?`}</P>

                        <Button
                            type="button"
                            width="large"
                            disabled={isPending}
                            onClick={handleSubmit}
                        >
                            Revoke
                        </Button>
                        <Button
                            variant="secondary"
                            onClick={handleClose}
                            width="large"
                            disabled={isPending}
                        >
                            Cancel
                        </Button>
                        {isError ? <QueryInlineError centered error={error} /> : null}
                    </>
                )}
            </Modal>
        </>
    );
};

export default RevokeUserTokens;
